export const QUERY_CACHE = Object.freeze({
  TCPA_LEGAL_LANGUAGE: 'TCPA_LEGAL_LANGUAGE',
})
